import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { formatDecimals } from 'global/helpers/numberFormatters'
import { getFormattedUnit } from 'global/helpers/units'
import { cloneElement, type ReactNode } from 'react'
import type { KNAttributeProps } from './types'

const KNAttribute = ({
  icon,
  label,
  value,
  suffix,
  size = 'small',
  stacked,
  hideEmpty,
}: KNAttributeProps): ReactNode => {
  const hasValue = value && (typeof value === 'number' ? value > 0 : true)
  if (!hasValue && hideEmpty) {
    return null
  }

  return (
    <Stack
      direction={stacked ? 'column' : 'row'}
      alignItems={stacked ? 'start' : 'center'}
      spacing={stacked ? 0 : 0.5}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        {icon && cloneElement(icon, {
          sx: {
            color: 'primary.light',
            fontSize: '1rem',
          },
        })}
        {label && (
          <Typography variant="p6" color="primary.light">
            {label}
          </Typography>
        )}
      </Stack>
      {hasValue ? (
        <Typography color="primary.main" variant={size === 'small' ? 'p5' : 'p4'}>
          {typeof value === 'number' ? formatDecimals(value) : value}
          {suffix && <small>&nbsp;{getFormattedUnit(suffix)}</small>}
        </Typography>
      ) : (
        <Typography color="primary.light" variant={size === 'small' ? 'p5' : 'p4'}>
          —
        </Typography>
      )}
    </Stack>
  )
}

export default KNAttribute
